(function () {
  'use strict';

  function getRSIFormData() {
    try {
      if (window._rsi && _rsi.u && typeof _rsi.u.serializeForm === 'function') {
        var data = _rsi.u.serializeForm(
          'form[method="post"][action*="/cart/add"]',
          '[name="form_type"][value="product"]'
        );
        if (data && data.indexOf('id') > -1) return data;
      }
    } catch (e) { }
    var varInput = document.querySelector('[data-variant-id-input]');
    var qtyInput = document.querySelector('[name="quantity"]');
    if (varInput && varInput.value) {
      return 'id=' + varInput.value + '&quantity=' + (qtyInput ? qtyInput.value || '1' : '1');
    }
    return 'product=true';
  }

  function openRSIForm() {
    if (window._rsi && _rsi.form && typeof _rsi.form.open === 'function') {
      try {
        _rsi.form.mode = 'productCart';
        if (_rsi.s && _rsi.s.form) { _rsi.s.form.currentPage = 'closed'; }
        _rsi.form.open(false, false, false, false, getRSIFormData());
        return;
      } catch (err) { }
    }
    var btn = document.querySelector('#_rsi-buy-now-button, ._rsi-buy-now-button');
    if (btn) { btn.click(); return; }
    var attempts = 0;
    var iv = setInterval(function () {
      attempts++;
      if (window._rsi && _rsi.form && typeof _rsi.form.open === 'function') {
        clearInterval(iv); openRSIForm(); return;
      }
      var b = document.querySelector('#_rsi-buy-now-button, ._rsi-buy-now-button');
      if (b) { clearInterval(iv); b.click(); return; }
      if (attempts >= 10) {
        clearInterval(iv);
        var form = document.getElementById('form-cod-embed');
        if (form) form.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 200);
  }

  if (!window.__builderBuyCTAProxy) {
    window.__builderBuyCTAProxy = true;
    document.addEventListener('click', function (e) {
      var cta = e.target.closest('[data-buy-cta]');
      if (!cta) return;
      e.preventDefault();
      e.stopPropagation();
      openRSIForm();
    });
  }
})();

/* ===========================================================================
   GUARD — descuento por cantidad de Releasit  (agregado 2026-07-27)
   ---------------------------------------------------------------------------
   PROBLEMA: Releasit calcula el descuento de las Quantity Offers en el
   navegador y lo manda dentro del payload (cartData.discounts); el servidor
   solo obedece. Dentro de recalculateData() las unidades se escriben en los
   inputs ocultos ANTES de armar el descuento, y ese tramo no tiene try/catch:
   si algo revienta ahi, el pedido se crea con 2+ unidades y descuento CERO
   (precio lleno). Medido: 6 de 198 pedidos multi-unidad (3%) entre el 3 y el
   27 de julio de 2026.

   QUE HACE: envuelve getFormData() y, si detecta ese estado roto justo antes
   del submit, resincroniza la oferta y fuerza un recalculo.

   REGLAS DE SEGURIDAD (importantes: esto corre en el submit del COD):
     - Solo REPARA, nunca bloquea. Ante cualquier duda devuelve el payload original.
     - Solo puede AGREGAR el descuento: si el recalculo alterara unidades o
       variantes, se descarta y se usa el original.
     - Todo envuelto en try/catch. Si Releasit cambia sus internos (_rsi es API
       no documentada), el guard deja de actuar sin romper el formulario.
   =========================================================================== */
(function () {
  'use strict';
  if (window.__vivaQOGuard) return;
  window.__vivaQOGuard = true;

  function unitsOf(data) {
    var n = 0;
    try {
      (data.formData || []).forEach(function (f) {
        if (f && typeof f.name === 'string' &&
            f.name.indexOf('item_quantity[qty_offer_') === 0) {
          n += parseInt(f.value, 10) || 0;
        }
      });
    } catch (e) { }
    return n;
  }

  function variantsOf(data) {
    var v = [];
    try {
      (data.formData || []).forEach(function (f) {
        if (f && typeof f.name === 'string' &&
            f.name.indexOf('item_variant_id[qty_offer_') === 0) {
          v.push(String(f.value));
        }
      });
    } catch (e) { }
    return v.sort().join(',');
  }

  function hasDiscount(data) {
    try {
      return !!(data && data.cartData && data.cartData.discounts &&
                data.cartData.discounts.length > 0);
    } catch (e) { return false; }
  }

  function tryRepair(original, callOriginal) {
    // Estado sano (o pedido de 1 unidad): no tocar nada.
    if (!original || hasDiscount(original)) return original;
    var units = unitsOf(original);
    if (units < 2) return original;

    var qo = window._rsi && window._rsi.form && window._rsi.form.quantityOffers;
    if (!qo || typeof qo.recalculateData !== 'function') return original;

    // El widget tiene que estar en el DOM: recalculateData() lee las variantes de ahi.
    var domEl = document.querySelector('._rsi-quantity-offers-selected');
    if (!domEl) return original;

    // Resincronizar la oferta en memoria con el tier que el cliente ve marcado.
    var domPos = domEl.getAttribute('data-offer-pos');
    if (domPos !== null && qo.currentOffer && qo.currentOffer.offers) {
      qo.currentOffer.offers.forEach(function (o) {
        if (String(o.pos) === String(domPos)) qo.selectedOfferIn = o;
      });
    }

    // Seguir solo si ese tier realmente tiene un descuento configurado.
    var sel = qo.selectedOfferIn;
    if (!sel || !sel.ds || sel.ds.t === 'none' || !(sel.ds.v > 0)) return original;

    qo.recalculateData();

    var fresh = callOriginal();
    // Aceptar el recalculo solo si agrego el descuento SIN alterar el pedido.
    if (hasDiscount(fresh) &&
        unitsOf(fresh) === units &&
        variantsOf(fresh) === variantsOf(original)) {
      if (window.__vivaQOGuardLog) {
        window.__vivaQOGuardLog.push({ at: Date.now(), units: units, fixed: true });
      }
      return fresh;
    }
    return original;
  }

  // Releasit carga async: esperar a que exista _rsi.form.getFormData para envolverlo.
  var tries = 0;
  var iv = setInterval(function () {
    try {
      if (++tries > 240) { clearInterval(iv); return; }   // ~60s
      var f = window._rsi && window._rsi.form;
      if (!f || typeof f.getFormData !== 'function') return;
      if (f.__vivaWrapped) { clearInterval(iv); return; }

      var orig = f.getFormData;
      f.getFormData = function () {
        var self = this, args = arguments;
        var data = orig.apply(self, args);
        try {
          return tryRepair(data, function () { return orig.apply(self, args); });
        } catch (e) {
          return data;   // ante cualquier fallo: comportamiento identico al de hoy
        }
      };
      f.__vivaWrapped = true;
      clearInterval(iv);
    } catch (e) {
      clearInterval(iv);
    }
  }, 250);
})();
